import React, {useState, useContext, useEffect} from 'react';
import { Link, useNavigate } from "react-router-dom";
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
//import logo from '../../images/logo/logo-new.png';
//import Preloader from '../../components/Preloader/Preloader';
import PasswordStrengthIndicator from '../../components/passwordStrengthIndicator';
import { useSnackbar } from 'notistack';
import { RoutesLocal } from '../../routes';
//import {Helmet} from 'react-helmet-async';
import { ProductContext } from '../../ProductProvider';
import logo from '../../assets/images/logo/arlogo.png';
const isNumberRegx = /\d/;
const specialCharacterRegx = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
const capsRegx=/[A-Z ]+/;
const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export default function ForgotPassword() {
    const { validateLogin, loginValidated, setLoginValidated, loggedUser } = useContext(ProductContext);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [username, setUsername]= useState('');
    const [confirmationCode, setConfirmationCode]= useState('');
    const [newPassword, setNewPassword] = useState('');
    const [nextPage, setNextPage]=useState(false);  
    const [loaded, setLoaded] = useState(true);
    const [newpasswordFocused, setNewPasswordFocused] = useState(false);
    const [newpasswordValidity, setNewPasswordValidity] = useState({
      minChar: null,
      number: null,
      specialChar: null,
      capsChar:null
    });
  
    useEffect(() => {
     if(!loggedUser.isAuthenticated && !loginValidated){
       setLoginValidated(true);
       validateLogin();
     }
   }, [])
  
    const handleSendAuthEmail=async(event)=>{
      event.preventDefault();
      try {
        if(username===""){
          enqueueSnackbar("Enter your registered eamil address!",{variant:'info'});
        }else if(!username.match(validRegex)){
         enqueueSnackbar("Enter your registered eamil address!",{variant:'info'});
       }else{
        setLoaded(false);
        const output = await resetPassword({ username });
        console.log("Output : ", output);
        enqueueSnackbar("Password Reset initiated!",{variant:'info'});
        handleResetPasswordNextSteps(output);
        setLoaded(true);
        }
      } catch (error) {
        console.log("Error Occured : ", error);
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        setLoaded(true);
      }  
     // setNextPage(true);
    }
  
    function handleResetPasswordNextSteps(output) {
      setLoaded(false);
      const { nextStep } = output;
      switch (nextStep.resetPasswordStep) {
        case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
          const codeDeliveryDetails = nextStep.codeDeliveryDetails;
          enqueueSnackbar(`Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`,{variant:'info'});
          setNextPage(true);
          setLoaded(true);
          // Collect the confirmation code from the user and pass to confirmResetPassword.
          break;
        case 'DONE':
          enqueueSnackbar('Password Reset Successful!',{variant:'info'});
          setLoaded(true);
          break;
      }
    
    }
  
    const handleConfirmResetPassword =async(event)=>{
      event.preventDefault();
      try {
        if(confirmationCode===""){
          enqueueSnackbar("Enter your code sent to your registered eamil address!",{variant:'info'});
        }else if(newPassword===""){
          enqueueSnackbar("Enter your new Password!",{variant:'info'});
        }else if(username===""){
          enqueueSnackbar("Enter your registered eamil address!",{variant:'info'});
        }else{
        setLoaded(false);
        await confirmResetPassword({ username, confirmationCode, newPassword })
        .then((res)=>{
          enqueueSnackbar("Your Password has been changed successfully! Login back with your New Password!",{variant:'info'});
        setLoaded(true);
        navigate("/auth/login");
        })
        .catch((error)=>{
          setLoaded(true);
          enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        })
      }
      } catch (error) {
        setLoaded(true);
        enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
      }  
    }
  
    const onNewChangePassword = password => {
      setNewPassword(password);
      
      setNewPasswordValidity({
          minChar: password.length >= 8 ? true : false,
          number: isNumberRegx.test(password) ? true : false,
          specialChar: specialCharacterRegx.test(password) ? true : false,
          capsChar:capsRegx.test(password)?true:false
      });
      };
       
  return (
    <div>
    <main>
<div className="container">

 <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
   <div className="container" style={{backgroundColor:"#f7fafc", borderRadius:"12px", padding:"2rem", boxShadow: "0 6px 18px rgba(0,0,0,0.08)"}}>
     <div className="row justify-content-center">
       <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

              <div className="d-flex justify-content-center py-1">
                <a href="https://archivesj.in" className="d-flex align-items-center w-auto">
                  <img src={logo} alt="" style={{width:"90px", height:"90px"}} />
                </a>
              </div>
              <h2 className="d-none d-lg-block ">Admin Office - Archives</h2>
              <p></p>

         <div className="card mb-3">

           <div className="card-body">

             <div className="pt-4 pb-2">
               <h5 className="card-title text-center pb-0 fs-4">Reset your Password</h5>
               <p className="text-center small">Enter your registered email and follow the instructions</p>
             </div>

             <form className="row g-3 needs-validation" noValidate>

               <div className="col-12">
                 <label htmlFor="yourUsername" className="form-label">Email Address</label>
                 <div className="input-group has-validation">
                   <span className="input-group-text" id="inputGroupPrepend">@</span>
                   <input type="email" name="username" className="form-control" id="yourUsername" required
                   onChange={event=>setUsername(event.target.value)}
                   value={username}
                   disabled={nextPage}/>
                   <div className="invalid-feedback">Please enter your username.</div>
                 </div>
               </div>

               {nextPage ?<>
               <div className="col-12">
                 <label htmlFor="yourPassword" className="form-label">Enter Code</label>
                 <input type="password" name="password" className="form-control" id="yourPassword" required 
                 onChange={event=>setConfirmationCode(event.target.value)}
                 value={confirmationCode}/>
                 <div className="invalid-feedback">Please enter your OTP!</div>
               </div>
               <div className="col-12">
                 <label htmlFor="yourNewPassword" className="form-label">New Password</label>
                 <input type="password" name="newpassword" className="form-control" id="yourNewPassword" required 
                 onFocus={() => setNewPasswordFocused(true)}
                 onChange={e => onNewChangePassword(e.target.value)}            
               value={newPassword}/>
                 {newpasswordFocused && <PasswordStrengthIndicator validity={newpasswordValidity} />}
                 <div className="invalid-feedback">Please enter your New password!</div>
               </div>
               </>:null}

               <div className="col-12">
                 <div className="form-check">
                   <input className="form-check-input" type="checkbox" name="remember" value="true" id="rememberMe"/>
                   <label className="form-check-label" htmlFor="rememberMe">Remember me</label>
                 </div>
               </div>
               <div className="col-12">
               {!nextPage?<button className="btn btn-primary w-100 rounded-pill shadow-sm" type="submit" onClick={event=>handleSendAuthEmail(event)}>Generate Code</button>
               :<button className="btn btn-primary w-100 rounded-pill shadow-sm" type="submit" onClick={event=>handleConfirmResetPassword(event)}>Reset Password</button>}
               </div>
               <div className="col-12">
                 <p className="small mb-0">Remember your password? <a href="pages-register.html"><Link to={RoutesLocal.Signin.path}>Sign In</Link></a></p>
               </div>
             </form>

           </div>
         </div>
       </div>
     </div>
   </div>

 </section>

</div>
</main>
</div>
)
}
